import { render, staticRenderFns } from "./CatalogProgressModal.vue?vue&type=template&id=20b20877&scoped=true&"
import script from "./CatalogProgressModal.vue?vue&type=script&lang=js&"
export * from "./CatalogProgressModal.vue?vue&type=script&lang=js&"
import style0 from "./CatalogProgressModal.vue?vue&type=style&index=0&id=20b20877&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20b20877",
  null
  
)

export default component.exports